import styled from "@emotion/styled";
import React from "react";
import { Marker } from "react-map-gl/maplibre";
import { AppCaregiver } from "../../../system/AppState/AppCaregiverState";
import { HeartFillIcon } from "../../../utils/icones";

export default function CaregiverMapMarker(props: {
  caregiver: Pick<AppCaregiver, "addressGeoLocation">;
  isActive: boolean;
  onClick: React.MouseEventHandler<Element>;
}) {
  return (
    <Marker
      latitude={props.caregiver.addressGeoLocation.lat}
      longitude={props.caregiver.addressGeoLocation.lng}
    >
      <DeadWhiteSpace onClick={props.onClick}>
        <CaregiverIcon data-active={props.isActive} as={HeartFillIcon} />
      </DeadWhiteSpace>
    </Marker>
  );
}

const DeadWhiteSpace = styled.div`
  padding: 12px;
`;

const CaregiverIcon = styled.svg<{ ["data-active"]: boolean }>`
  --size: 16px;
  color: var(--primary-color);
  width: var(--size);
  height: var(--size);
  padding: 8px;
  background-color: white;
  border-radius: calc(100% / 3);
  border: 4px solid var(--tw-blue-200);
  transition: transform 0.2s ease-in-out;

  &[data-active="true"] {
    transform: scale(1.5);
    background-color: var(--primary-color);
    color: white;
  }
`;
